module.exports = __webpack_public_path__ + "static/media/up-arrow.87eee203.svg";